import axios from "axios";
import config from '../environment/config';
import { authHeader } from "./auth.header";


const API_URL = config.API_URL.endsWith('/') ? config.API_URL : `${config.API_URL}/`;


const handleApiError = (error, functionName) => {
  if (error.response) {
    
    console.error(`${functionName} - Status ${error.response.status}:`, error.response.data);
    if (error.response.status === 404) {
      console.error(`Endpoint not found. Check your backend API routes.`);
    }
  } else if (error.request) {
    
    console.error(`${functionName} - No response:`, error.request);
  } else {
   
    console.error(`${functionName} - Error:`, error.message);
  }
  throw error;
};


export const getProductById = async (productId) => {
  const url = `${API_URL}api/seo-product-details/${productId}`;
  console.log('Fetching product URL:', url);
  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()  // ✅ Use your existing auth header helper
      }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getProductById');
  }
};



export const getAllProducts = async (categoryId) => {
  const url = `${API_URL}api/seo-product-details/category/${categoryId}`;
  console.log('Fetching products URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getAllProducts');
  }
};


export const getFeatureByProduct = async (productId) => {
  const url = `${API_URL}api/seo-product-features?productId=${productId}`;
  console.log('Fetching features URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getFeatureByProduct');
  }
};


export const getProductFeatures = async () => {
  const url = `${API_URL}api/seo-product-features`;
  console.log('Fetching all product features URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getProductFeatures');
  }
};


export const getAllCategory = async () => {
  const url = `${API_URL}api/categories`;
  console.log('Fetching categories URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getAllCategory');
  }
};


export const getPlansByProduct = async (productId) => {
  const url = `${API_URL}api/seo-product-plans?productId=${productId}`;
  console.log('Fetching plans URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getPlansByProduct');
  }
};


export const getSpecificationsByProduct = async (productId) => {
  const url = `${API_URL}api/seo-product-specifications?productId=${productId}`;
  console.log('Fetching specifications URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getSpecificationsByProduct');
  }
};


export const getReviewsByProduct = async (productId) => {
  const url = `${API_URL}api/seo-product-reviews/product/${productId}`;
  console.log('Fetching reviews URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getReviewsByProduct');
  }
};


export const getSupportByProduct = async (productId) => {
  const url = `${API_URL}api/seo-product-supports/product/${productId}`;
  console.log('Fetching support URL:', url);
  try {
    const response = await axios.get(url, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'getSupportByProduct');
  }
};